import { render, staticRenderFns } from "./RevokeRequestModal.vue?vue&type=template&id=a6272a32"
import script from "./RevokeRequestModal.vue?vue&type=script&lang=js"
export * from "./RevokeRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports